/** SWIFT/BIC: 8 or 11 alphanumeric characters (spaces ignored). */
export function validateSwiftBic(value: string | null | undefined): boolean {
  if (!value) return false
  const clean = value.replace(/\s/g, '').toUpperCase()
  return (clean.length === 8 || clean.length === 11) && /^[A-Z0-9]{8,11}$/.test(clean)
}

export function normalizeSwiftBic(value: string): string {
  return value.replace(/\s/g, '').toUpperCase().slice(0, 11)
}
